import { PROFILE_INFO, SIGN_IN, UPDATE_OUTOFOFFICE } from "../action-types/userActionTypes";

export function updateUser(data: any) {
    return {
        type: SIGN_IN,
        payload: data
    }
}

export function updateAdjusterSchedule(data: any) {
    return {
        type: PROFILE_INFO,
        payload: data
    }
}

export function updateOutOfOffice(data: any) {
    return {
        type: UPDATE_OUTOFOFFICE,
        payload: data
    }
}


